import { render, staticRenderFns } from "./Inventor.vue?vue&type=template&id=0b0f7a85&"
import script from "./Inventor.vue?vue&type=script&lang=js&"
export * from "./Inventor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports